import React from 'react'
import { Info } from 'lucide-react'
import { Alert, AlertDescription, Checkbox, Label } from '../ui'

// Control compartido de las pantallas con selector de temporada: por defecto solo
// se ven los inscritos, con un escape para ver al resto. Va en la toolbar, junto
// al selector de temporada.
//
// Se apoya en useInscritosTemporada; aqui solo vive la parte visible, para que las
// cinco pantallas se vean y se comporten igual.
export const FiltroInscritos = ({ estado, id = 'ver-no-inscritos' }) => {
  const { hayPadron, verNoInscritos, setVerNoInscritos } = estado || {}
  if (!hayPadron) return null

  return (
    <div className="flex items-center gap-2 whitespace-nowrap">
      <Checkbox id={id} checked={verNoInscritos} onCheckedChange={(v) => setVerNoInscritos(!!v)} />
      <Label htmlFor={id} className="cursor-pointer text-sm font-normal text-muted-foreground">
        Ver no inscritos
      </Label>
    </div>
  )
}

// Temporada sin un solo inscrito: no se filtra nada, y hay que decir por que. Sin
// el aviso, el admin ve la lista completa y concluye que el filtro no sirve.
export const AvisoSinPadron = ({ estado }) => {
  if (!estado?.sinPadron) return null
  return (
    <Alert className="py-2">
      <Info className="h-4 w-4" />
      <AlertDescription className="text-xs">
        Esta temporada aún no tiene inscritos, así que se muestran todos los jugadores.
        Inscríbelos en Administración → Inscripciones.
      </AlertDescription>
    </Alert>
  )
}

export default FiltroInscritos
